import { useState, useEffect, useMemo } from 'react';
import OutsideClickHandler from 'react-outside-click-handler';
import { useLazyQuery, useMutation } from '@apollo/client';
import { UPDATE_ACCESS_MODULE } from '../../graphql/GraphqlMutation';
import { 
    // useDispatch, 
    useSelector } from "react-redux";
// import { set_Pin_UnPin_user } from '../../redux/adminSlice';
import { GET_MY_PROFILE_ROLES } from '../../graphql/GraphqlQueries';
import { labels, iconMap } from "../../utils/Common_module";
// import ERPNextLauncher from "../../services/ERPNextLauncher";
import pinnedIcon from "../../media/images/icons/assets_dark_hover/solid-room-pin-hover.svg";




const LeftMoreOptions = ({ setMoreOptions, setMoreOptionsShow, showNotify, goRouteoptions, userMe }) => {

    // const dispatch = useDispatch();
    const pinuser = useSelector(state => state.admin.pinAccess) || [];
    const [loader, setLoader] = useState(true)
    const [erpNext, setErpNext] = useState([]);
    const [pin, setPin] = useState([]);

    const [getRoles] = useLazyQuery(GET_MY_PROFILE_ROLES,
        {
            fetchPolicy: 'cache',
            onCompleted: (data) => {
                console.log(25, data.get_my_profile_roles?.data.map((v) => v.profile))
                setErpNext(data.get_my_profile_roles?.data.map((v) => v.profile))
                setLoader(false)
            }
        }
    );
    useEffect(() => {
        const callApi = async () => {
            await getRoles();
        }
        if (userMe) {
            if (userMe?.erpNext) {
                callApi();
            } else {
                setLoader(false);
            }
        }
    }, [userMe, getRoles]);
    useEffect(() => {
        setPin(pinuser);
    }, [pinuser]);
    const mergedList = useMemo(() => {
        const totalRequired = 5;
        return (pin || []).map((item, index) => ({
            name: item,
            label: labels?.[item] || item,
            pin: index < totalRequired,
        }));
    }, [pin, labels]);

    // const goRouteErp = (routeName) => {
    //     if (userMe?.erpNext) {
    //         setMoreOptions("erpNext");
    //         setMoreOptionsShow(false);
    //         ERPNextLauncher(userMe, routeName);
    //         return;
    //     }
    // };

    const [updateUserRes] = useMutation(UPDATE_ACCESS_MODULE);

    // const handlePin = (module) => {
    //     setPin(prevPin => {
    //         const index = prevPin.findIndex(item => item === module.name);
    //         let newPin = [...prevPin];

    //         if (index > -1) {
    //             const [removed] = newPin.splice(index, 1);

    //             if (module.pin) {
    //                 newPin.push(removed);
    //             } else {
    //                 newPin.splice(1, 0, removed);
    //             }
    //         }

    //         handleSubmit(newPin);

    //         return newPin;
    //     });
    // };

    // const handleSubmit = async (newPin) => {
    //     try {
    //         const { data } = await updateUserRes({
    //             variables: {
    //                 input: {
    //                     user_id: userMe?.id,
    //                     pin_access: newPin,
    //                     unpin_access: []
    //                 }
    //             }
    //         });

    //         if (data?.update_user?.status) {
    //             dispatch(
    //                 set_Pin_UnPin_user({
    //                     pinAccess: newPin || [],
    //                     unPinAccess: []
    //                 })
    //             );
    //         }
    //     } catch (error) {
    //         console.error("GraphQL Error:", error);
    //     }
    // };

    return (
        loader ?
            <OutsideClickHandler onOutsideClick={() => setMoreOptionsShow(false)}>
                <div className={`filterActionPopup !z-[9999] !max-h-[370px] overflow-auto ${showNotify ? '!top-[225px]' : '!top-[176px]'}`}>
                    <div className="filterActionHeader flex justify-between items-center px-[20px] py-[8px]">
                        <span className="popup_header font-poppins text-[16px] font-semibold text-text-body dark:text-text-light">
                            All modules
                        </span>
                        <span className="close_pinnen_popup cursor-pointer" onClick={() => setMoreOptionsShow(false)}></span>
                    </div>
                    <ul className="filterActionList !px-[16px] pb-[8px]">
                        {Array.from({ length: 5 }).map((_, idx) => (
                            <li key={idx} className="flex justify-between items-center py-2 animate-pulse">
                                <div className="flex items-center gap-2">
                                    <div className="w-[24px] h-[24px] bg-gray-300 dark:bg-gray-700 rounded"></div>
                                    <div className="w-[100px] h-[16px] bg-gray-300 dark:bg-gray-700 rounded"></div>
                                </div>
                                <div className="w-[24px] h-[24px] bg-gray-300 dark:bg-gray-700 rounded"></div>
                            </li>
                        ))}
                    </ul>
                </div>
            </OutsideClickHandler>
            :
            <OutsideClickHandler onOutsideClick={() => setMoreOptionsShow(false)}>
                <div className={`filterActionPopup !z-[9999] max-h-[360px] overflow-y-auto ${showNotify ? '!top-[225px]' : '!top-[176px]'} `}>
                    <div className="filterActionHeader flex justify-between items-center px-[20px] py-[8px]">
                        <span className="popup_header font-poppins text-[16px] font-semibold leading-[1.5] tracking-normal text-left text-text-body dark:text-text-light">All modules</span>
                        <span className="close_pinnen_popup cursor-pointer" onClick={() => setMoreOptionsShow(false)}></span>
                    </div>
                    <ul className="filterActionList !px-[16px] pb-[8px]">
                        {mergedList?.map((item, index) => {
                            return (
                                <div key={index} className="flex justify-between items-center py-2 cursor-pointer">
                                    <div className="flex items-center gap-2" onClick={() => { goRouteoptions(item); setMoreOptionsShow(false); }} title={item.label}>
                                        <div className={iconMap[item.label] || "filehub_icon"}></div>
                                        <span className="font-poppins text-[16px] font-normal leading-[1.5] tracking-normal text-left !text-text-action hover:!text-text-action-hover dark:hover:!text-grey-200 dark:!text-text-light">{item.label}</span>
                                    </div>

                                    <div className="cursor-pointer w-[24px] h-[24px]">
                                        {/* <div className={`pinIcon ${item.pin ? "PinFilled" : "PinOutline"}`}></div> */}
                                        {item.pin && (
                                            <span
                                                className="pinIcon relative inline-block w-[16px] h-[16px] top-[3px] bg-gray-300 dark:bg-gray-300 cursor-pointer transition-colors"
                                                style={{
                                                    WebkitMaskImage: `url(${pinnedIcon})`,
                                                    WebkitMaskRepeat: "no-repeat",
                                                    WebkitMaskPosition: "center",
                                                    WebkitMaskSize: "contain",
                                                    maskImage: `url(${pinnedIcon})`,
                                                    maskRepeat: "no-repeat",
                                                    maskPosition: "center",
                                                    maskSize: "contain",
                                                }}
                                            />
                                        )}
                                    </div>

                                    {/* }
                                    <div className="cursor-pointer w-[24px] h-[24px]" onClick={() => { handlePin(item);}}>
                                        <div className={`pinIcon ${item.pin ? "PinFilled" : "PinOutline"}`}></div>
                                    </div>
                                    */}

                                </div>
                            );
                        })}

                        {/*  {erpNext?.map((item, index) => {
                            return (
                                <div key={index} className="flex justify-between items-center py-2 cursor-pointer">
                                    <div className="flex items-center gap-2" onClick={() => goRouteErp(item)} title={item}>
                                        <span className={`w-[24px] h-[24px] noti_icon ${getIcon(item)}`}></span>
                                        <span className="font-poppins text-[16px] font-normal leading-[1.5] tracking-normal text-left !text-text-action hover:!text-text-action-hover dark:hover:!text-text-action-hover dark:!text-text-light">
                                            {`${item} module`}
                                        </span>
                                    </div>
                                </div>
                            );
                        })}
                            */}

                    </ul>
                </div>
            </OutsideClickHandler>
    );
};

export default LeftMoreOptions;
